import(/* webpackMode: "eager", webpackExports: ["OurTeam"] */ "/vercel/path0/src/app/(frontend)/components/OurTeam/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RefreshRouteOnSave"] */ "/vercel/path0/src/app/(frontend)/components/RefreshRouteOnSave/index.tsx");
